import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { UserImportReportsView } from './views/UserImportReportsView';
import { DefaultView, Views } from '../../types/BlockWithViews';

type UserImportReportsProps = Views<DefaultView<UserImportReportsView>>;

function UserImportReports({ views }: UserImportReportsProps) {
  return (<UserImportReportsView {...views.default} />);
}

export const UserImportReportsBlock = asFetchableBlock(
  UserImportReports,
  BlockType.userimportreports,
);
export type UserImportReportsBlock = ComponentProps<typeof UserImportReportsBlock>;
